<template>
	<el-dialog title="Editar Usuário" :visible.sync="show" :before-close="closeModal" :close-on-click-modal="false">
		<div>
			<div class="md-layout">
				<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-large-size-50 md-xlarge-size-50 user-field">
					<label>Usuario</label>
					<el-input v-model="user.username"></el-input>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-large-size-50 md-xlarge-size-50 user-field">
					<label>Nome</label>
					<el-input v-model="user.firstname"></el-input>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-large-size-50 md-xlarge-size-50 user-field">
					<label>Sobrenome</label>
					<el-input v-model="user.lastname"></el-input>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-large-size-50 md-xlarge-size-50 user-field">
					<label>Email</label>
					<el-input v-model="user.email"></el-input>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-large-size-50 md-xlarge-size-50 user-field">
					<label>Telefone</label>
					<el-input v-model="user.mobile"></el-input>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-large-size-50 md-xlarge-size-50 user-field">
					<label>Nivel</label>
					<el-select v-model="user.level.name" placeholder="Select" style="width: 100%">
						<el-option
							v-for="item in levels"
							:key="item.id"
							:label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-large-size-50 md-xlarge-size-50 user-field user-field--checkbox">
					<label>Email Semanal</label>
					<el-checkbox v-model="user.weekly_email"></el-checkbox>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-large-size-50 md-xlarge-size-50 user-field user-field--checkbox">
					<label>Usuário ativo (todas as rádios)</label>
					<el-switch ref="active-switch" v-model="user.active"></el-switch>
				</div>
			</div>
			<div class="md-layout">
				<div
					class="md-layout-item md-small-size-100 md-medium-size-30 md-large-size-30 md-xlarge-size-20">
					<md-button class="md-info md-block" @click="updateUser()">
						Salvar</md-button>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import { Dialog, Tabs, TabPane, Input, Checkbox, Select, Option, Switch } from 'element-ui'
	import Swal from 'sweetalert2';
	import models from "@/routes/models";
	import jwt_decode from "jwt-decode";
	import isUserActive from "@/utils/isUserActive";
	export default {
		components: {
			[Dialog.name]: Dialog,
			[Tabs.name]: Tabs,
			[TabPane.name]: TabPane,
			[Input.name]: Input,
			[Checkbox.name]: Checkbox,
			[Select.name]: Select,
			[Option.name]: Option,
			[Switch.name]: Switch

		},
		data() {
			name: 'edit-user'
			return {
				show: false,
				user: {
					id: '',
					username: '',
					firstname: '',
					lastname: '',
					email: '',
					mobile: '',
					level: {
						id: '',
						name: ''
					},
					weekly_email: false,
					active: true
				},
				select_level: '',
				levels: [
					{ id:0, name: 'Administrador' },
					{ id:1, name: 'Gerente MobRadio' },
					{ id:2, name: 'Usuário do Painel' }
				]
			}
		},
		methods: {
			openModal(user) {
				this.user = user
				this.user.active = isUserActive(user.active)
				this.show = true
			},
			closeModal() {
				Swal.fire({
					title: 'Atenção',
					text: "Você está prestes a cancelar o preenchimento do formulário e todas as informações serão perdidas. Deseja continuar?",
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Sim',
					cancelButtonText: 'Não'
				}).then((result) => {
					if (result.value) {
						this.show = false
					}
				});
			},
			updateUser() {
				let level
				if(this.user.level.name === "Administrador") { level = 0 }
				if(this.user.level.name === "Gerente MobRadio") { level = 1 }
				if(this.user.level.name === "Usuário do Painel") { level = 2 }
				let formData = {
					id: this.user.id,
					username: this.user.username,
					firstname: this.user.firstname,
					lastname: this.user.lastname,
					email: this.user.email,
					mobile: this.user.mobile,
					level: level,
					weekly_email: this.user.weekly_email,
					active: this.user.active,
					// lida na hora de salvar: a rádio pode ter sido trocada no seletor depois que a página abriu
					radioId: jwt_decode(localStorage.getItem('APP_01')).radio.id
				}
				models().post('/users/updateUserByRadio', formData)
					.then(() => {
						Swal('', 'Usuário atualizado', "success")
						this.show = false
						this.$root.$emit('userUpdated')
					})
					.catch((err) => {
						// ex.: 404 quando o usuário não tem vínculo com a rádio — nada foi salvo
						const message = (err && err.response && err.response.data && err.response.data.message)
							|| 'Não foi possível atualizar o usuário.'
						Swal('Erro', message, 'error')
					})
			}
		},
		mounted() {
			this.$root.$on("editUser", (payload) => {
				this.openModal(payload)
			})
		}
	}
</script>

<style scoped>
	.user-field {
		margin-bottom: 20px;
	}
	.user-field label {
		display: block;
		margin: 0 0 6px;
	}
	.user-field--checkbox {
		display: flex;
		align-items: center;
	}
	.user-field--checkbox label {
		margin: 0 8px 0 0;
	}
</style>
